module.exports = __webpack_public_path__ + "img/office-red.cc65d2d1.png";